import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ArrowIcon from "../icons/arrowIcon";
import { pizze } from "./constants";
import {
  Container,
  Description,
  Header,
  ItemContainer,
  Price,
  PriceOption,
  PricesWrapper,
  TextWrapper,
  Title,
} from "./styles";

export const Pizza = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Header>
        <span
          onClick={() => navigate("/food")}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <ArrowIcon />
          <p>{t("Pizze")}</p>
        </span>
      </Header>

      <Container>
        {pizze.map((item, index) => (
          <ItemContainer
            key={`${item.title}-${index}`}
            isFirst={item.isFirst}
          >
            <TextWrapper isDescription={Boolean(item.description)}>
              <Title>{t(item.title)}</Title>

              {item.description && (
                <Description>({t(item.description)})</Description>
              )}
            </TextWrapper>

            <PricesWrapper>
              {item.prices.map((option) => (
                <PriceOption key={`${item.title}-${option.size}`}>
                  <span>{option.size}/</span>
                  <Price>{option.price}</Price>
                </PriceOption>
              ))}
            </PricesWrapper>
          </ItemContainer>
        ))}
      </Container>
    </>
  );
};